module.exports = __webpack_public_path__ + "static/media/675.6edba41c.webp";